(ns re-frame.flow.alpha
  (:require
   #?(:cljs [re-frame.db :as db])
   [re-frame.utils :as u]
   [re-frame.registrar :refer [get-handler]]
   [re-frame.loggers     :refer [console]]
   [re-frame.interceptor :refer [->interceptor get-effect
                                 get-coeffect assoc-effect]]
   [re-frame.interop :as interop]
   [re-frame.trace :as trace :include-macros true]
   #?(:cljs [reagent.core :as r])))

(def db-path? vector?)

(def flow? map?)

(def flow<-? (comp some? ::flow<-))

(def flows (interop/ratom {}))

(def flow-states (atom {}))

(defn input-ids [{:keys [inputs live-inputs]}]
  (vec (distinct (into []
                       (comp (remove db-path?)
                             (map #(or (::flow<- %) %)))
                       (concat (vals inputs) (vals live-inputs))))))

(defn topsort [flows]
  (->> flows
       (u/map-vals input-ids)
       u/remove-orphans
       u/topsort-kahn
       reverse
       (map flows)))

(def topsort* (u/memoize-one topsort))

(defn default [id]
  {:id          id
   :path        (if (sequential? id) (vec id) [id])
   :inputs      {}
   :output      (constantly true)
   :live?       (constantly true)
   :live-inputs {}
   :cleanup     u/deep-dissoc})

(defn stale-in-flows [flows {:keys [inputs]}]
  (reduce-kv (fn [m k {:keys [path]}]
               (cond-> m
                 (contains? (set (vals inputs)) path) (assoc k path)))
             {}
             flows))

(defn stale-out-flows [flows {:keys [path]}]
  (reduce-kv (fn [m k {:keys [inputs]}]
               (let [bad-inputs (into {} (filter (comp #{path} val)) inputs)]
                 (cond-> m (seq bad-inputs) (assoc k bad-inputs))))
             {}
             flows))

(defn validate-inputs [{:keys [inputs]}]
  (doseq [[_ input] inputs
          :when (not ((some-fn db-path? flow<-?) input))]
    (throw (#?(:clj Exception. :cljs js/Error.) "bad input"))))

(defn warn-stale-dependencies [flows new-flow]
  (let [ins (stale-in-flows flows new-flow)
        outs (stale-out-flows flows new-flow)
        warn-ins (fn [[id path]]
                   ["- Input" (str path)
                    "matches the output path of" (str id) ".\n"
                    "  For an explicit dependency, change it to (re-frame/flow<-"
                    (str id ").") "\n"])
        warn-outs (fn [[id inputs]]
                    (mapcat (fn [[input-id _]]
                              ["- Output" (str (:path new-flow))
                               "matches the input" (str input-id)
                               "of the flow" (str id ".\n")
                               "  For an explicit dependency, change that input to"
                               "(re-frame/flow<-" (str (:id new-flow) ").") "\n"])
                            inputs))
        warnings (concat (mapcat warn-ins ins) (mapcat warn-outs outs))]
    (when (seq warnings)
      (apply console :warn "Warning: You called `reg-flow` with the flow" (str (:id new-flow))
             "but this created stale dependencies.\n"
             "Your flows may not evaluate in the correct order.\n"
             warnings))))

(defn reg-flow
  ([k m]
   (reg-flow (assoc m :id k)))
  ([m]
   (validate-inputs m)
   (warn-stale-dependencies @flows m)
   (swap! flow-states update ::registered (fnil conj #{}) (:id m))
   (swap! flows assoc (:id m)
          (-> (merge (default (:id m)) m)
              (with-meta #?(:cljs
                            {::ref (r/reaction (get-in @db/app-db (:path m)))}))))))

(defn clear-flow
  ([]
   (swap! flows empty)
   (swap! flow-states update ::cleared into @flows))
  ([id]
   (when-let [flow (get @flows id)]
     (swap! flows dissoc id)
     (swap! flow-states update ::cleared assoc (:id flow) flow))))

(defn flow<- [id] {::flow<- id})

(def flow-fx-ids #{:reg-flow :clear-flow})

(defn do-effect [[k v]]
  (let [handler (case k :reg-flow reg-flow :clear-flow clear-flow)]
    (handler v)))

(def remove-fx (partial remove (comp flow-fx-ids first)))

(def dissoc-fx #(apply dissoc % flow-fx-ids))

(def do-fx
  (->interceptor
   {:id :do-flow-fx
    :after (fn [{{:keys [fx] :as effects} :effects
                 :as ctx}]
             (let [flow-fx (concat (select-keys effects flow-fx-ids)
                                   (filterv (comp flow-fx-ids first) fx))]
               (doall (map do-effect flow-fx))
               (-> ctx
                   (update-in [:effects :fx] remove-fx)
                   (update :effects dissoc-fx))))}))

(defn resolve-input [db flows input]
  (if (vector? input)
    (get-in db input)
    (some->> input ::flow<- flows :path (resolve-input db flows))))

(defn resolve-inputs [db flows inputs]
  (if (empty? inputs) db (u/map-vals (partial resolve-input db flows) inputs)))

(defn run [ctx {:keys   [path cleanup live? inputs live-inputs output id]
                flow-fx :fx
                ::keys  [cleared?]
                :as     flow}]
  (let [new?   (contains? (::registered @flow-states) id)
        old-db (get-coeffect ctx :db)
        db     (or (get-effect ctx :db) old-db)
        fx     (get-effect ctx :fx)

        id->old-in (resolve-inputs old-db (:flows ctx) inputs)
        id->in     (resolve-inputs db (:flows ctx) inputs)
        dirty?     (not= id->in id->old-in)

        id->old-live-in (resolve-inputs old-db (:flows ctx) live-inputs)
        id->live-in     (resolve-inputs db (:flows ctx) live-inputs)

        old-output (get-in old-db path)

        bardo [(cond new? :registered (live? (assoc id->old-live-in :db old-db)) :live :else :dead)
               (cond cleared? :cleared (live? (assoc id->live-in :db db)) :live :else :dead)]

        new-db (case bardo
                 [:live :live]       (cond-> db dirty? (assoc-in path (output id->in id->old-in old-output)))
                 [:live :dead]       (cleanup db path)
                 [:dead :live]       (assoc-in db path (output id->in id->old-in old-output))
                 [:registered :live] (do (swap! flow-states update ::registered disj id)
                                            (assoc-in db path (output id->in id->old-in old-output)))
                 [:live :cleared]    (cleanup db path)
                 nil)

        new-fx (when flow-fx
                 (case bardo
                   [:live :live]       (when dirty? (concat fx (flow-fx id->in id->old-in old-output)))
                   [:dead :live]       (concat fx (flow-fx id->in id->old-in old-output))
                   [:registered :live] (concat fx (flow-fx id->in id->old-in old-output))
                   nil))]
    (trace/with-trace {:operation id
                       :op-type   :flow
                       :tags      {:flow-spec       flow
                                   :transition      bardo
                                   :db              db
                                   :new-db          new-db
                                   :id->in          id->in
                                   :id->old-in      id->old-in
                                   :id->live-in     id->live-in
                                   :id->old-live-in id->old-live-in}}
      (cond-> ctx
        new-db (assoc-effect :db new-db)
        new-fx (assoc-effect :fx new-fx)))))

(defn with-cleared [m]
  (merge (update-vals (::cleared @flow-states) #(assoc % ::cleared? true)) m))

(def interceptor
  (->interceptor
   {:id    :flow
    :after (comp (fn [ctx]
                   (let [all-flows (with-cleared @flows)]
                     (swap! flow-states dissoc ::cleared)
                     (reduce run
                             (assoc ctx :flows all-flows)
                             (topsort* all-flows))))
                 (fn [{{:keys [db]} :effects :as ctx}]
                   (assoc ctx :re-frame/pre-flow-db db)))}))
